import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = { class: "text-xl font-semibold text-white" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm font-normal text-gray-400"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_6 = { class: "min-h-[600px] flex flex-col" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center items-center py-16 flex-grow"
}
const _hoisted_8 = {
  key: 1,
  class: "space-y-6 flex-grow"
}
const _hoisted_9 = { class: "flex flex-col md:flex-row md:items-start" }
const _hoisted_10 = { class: "flex-shrink-0 mb-4 md:mb-0 md:mr-6" }
const _hoisted_11 = { class: "flex-grow" }
const _hoisted_12 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4" }
const _hoisted_13 = { class: "text-lg font-medium text-white mb-1" }
const _hoisted_14 = { class: "flex items-center space-x-3" }
const _hoisted_15 = { class: "mr-1" }
const _hoisted_16 = { class: "text-xs text-gray-500 bg-gray-700 px-2 py-1 rounded" }
const _hoisted_17 = { class: "text-sm text-gray-400" }
const _hoisted_18 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_19 = { class: "text-gray-300 leading-relaxed" }
const _hoisted_20 = {
  key: 1,
  class: "mb-4 p-4 bg-gray-700 rounded-lg border-l-4 border-blue-500"
}
const _hoisted_21 = { class: "text-gray-300" }
const _hoisted_22 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-3 pt-4 border-t border-gray-700" }
const _hoisted_23 = { class: "font-medium" }
const _hoisted_24 = {
  key: 2,
  class: "bg-gray-800 rounded-lg p-12 text-center flex-grow flex items-center justify-center"
}
const _hoisted_25 = { class: "max-w-md mx-auto" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "text-lg font-medium text-white mb-2" }
const _hoisted_28 = { class: "text-gray-400 mb-6" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  class: "w-5 h-5 mr-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_32 = ["d"]
const _hoisted_33 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(" Ocene kao " + _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac') + " ", 1),
        (_ctx.ratingFilter !== 'all')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_ctx.ratingFilter === 'positive' ? 'pozitivne' : 'negativne') + ") ", 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.meta.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Ukupno: " + _toDisplayString(_ctx.meta.total) + " ocena ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
          ])))
        : (!_ctx.loading && _ctx.ratings.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratings, (rating) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: rating.id,
                  class: _normalizeClass(["bg-gray-800 rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow border-l-4", {
            'border-green-500': rating.isLike,
            'border-red-500': !rating.isLike,
          }])
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["rounded-full w-12 h-12 flex items-center justify-center text-lg font-bold", {
                  'bg-green-100 text-green-800': rating.isLike,
                  'bg-red-100 text-red-800': !rating.isLike,
                }])
                      }, _toDisplayString(rating.fromUser.username.charAt(0).toUpperCase()), 3)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_13, _toDisplayString(rating.fromUser.username), 1),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium flex items-center", {
                        'bg-green-900 text-green-300': rating.isLike,
                        'bg-red-900 text-red-300': !rating.isLike,
                      }])
                            }, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(rating.isLike ? '👍' : '👎'), 1),
                              _createTextVNode(" " + _toDisplayString(rating.isLike ? 'Pozitivna ocena' : 'Negativna ocena'), 1)
                            ], 2),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.userRole === 'seller' ? 'Prodaja' : 'Kupovina'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDate(rating.createdAt)), 1)
                      ]),
                      (rating.comment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(rating.comment), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (rating.reply)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center mb-2" }, [
                              _createElementVNode("svg", {
                                class: "w-4 h-4 text-blue-400 mr-2",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                                })
                              ]),
                              _createElementVNode("span", { class: "text-sm font-medium text-blue-400" }, "Vaš odgovor:")
                            ], -1)),
                            _createElementVNode("p", _hoisted_21, _toDisplayString(rating.reply), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'product-detail',
                    params: { id: rating.product.slug },
                  },
                          class: "text-blue-400 hover:text-blue-300 transition-colors flex items-center group"
                        }, {
                          default: _withCtx(() => [
                            _cache[2] || (_cache[2] = _createElementVNode("svg", {
                              class: "h-4 w-4 mr-2 group-hover:translate-x-1 transition-transform",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(rating.product.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ]))
          : (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["w-16 h-16 mx-auto rounded-full flex items-center justify-center", {
                'bg-blue-900': _ctx.userRole === 'seller',
                'bg-green-900': _ctx.userRole === 'buyer',
              }])
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["w-8 h-8", {
                  'text-blue-400': _ctx.userRole === 'seller',
                  'text-green-400': _ctx.userRole === 'buyer',
                }]),
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                        }, null, -1)
                      ]), 2))
                    ], 2)
                  ]),
                  _createElementVNode("h3", _hoisted_27, " Nemate ocene kao " + _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac'), 1),
                  _createElementVNode("p", _hoisted_28, [
                    (_ctx.ratingFilter !== 'all')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, " Nemate " + _toDisplayString(_ctx.ratingFilter === 'positive' ? 'pozitivnih' : 'negativnih') + " ocena kao " + _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac') + ". ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.userRole === 'seller'
                  ? 'Kada prodajete proizvode, kupci će moći da vas ocenjuju.'
                  : 'Kada kupujete proizvode, prodavci će moći da vas ocenjuju.'), 1))
                  ]),
                  _createVNode(_component_router_link, {
                    to: _ctx.userRole === 'seller' ? '/create-product' : '/products',
                    class: "inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white rounded-lg transition-colors"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("svg", _hoisted_31, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: 
                  _ctx.userRole === 'seller'
                    ? 'M12 6v6m0 0v6m0-6h6m-6 0H6'
                    : 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                
                        }, null, 8, _hoisted_32)
                      ])),
                      _createTextVNode(" " + _toDisplayString(_ctx.userRole === 'seller' ? 'Dodaj novi oglas' : 'Pregledaj proizvode'), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_PaginationComponent, {
        meta: _ctx.meta,
        "current-page": _ctx.currentPage,
        onPageChange: _ctx.handlePageChange
      }, null, 8, ["meta", "current-page", "onPageChange"])
    ])
  ]))
}